import { createSlice } from "@reduxjs/toolkit";
import { FilterStateAccessRequestStoreBackOffice } from "./types";

const INITIAL_STATE: FilterStateAccessRequestStoreBackOffice = {
  filters: {
    search: "",
    store_code: "",
    status: "",
    from_date: "",
    to_date: "",
    orderBy: {},
    meta: {
      page: 1,
      perPage: 10,
    },
  },
};

const accessRequestStoreBackOfficeFilterSlice = createSlice({
  name: "accessRequestStoreBackOfficeFilter",
  initialState: INITIAL_STATE,
  reducers: {
    setAccessRequestStoreBackOfficeFilter(state, action) {
      const { key, value } = action.payload;
      
      if (key === 'meta') {
        state.filters.meta = {
          ...state.filters.meta,
          ...value,
        };
      } else {
        state.filters[key] = value;
      }
    },
    clearAccessRequestStoreBackOfficeFilters(state) {
      state.filters = { ...INITIAL_STATE.filters };
    },
  },
});

export const { 
  setAccessRequestStoreBackOfficeFilter, 
  clearAccessRequestStoreBackOfficeFilters 
} = accessRequestStoreBackOfficeFilterSlice.actions;

export default accessRequestStoreBackOfficeFilterSlice.reducer;